import { ElementRef, Injectable } from '@angular/core';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { ToasterService } from '../providers/toaster/toaster.service';
@Injectable({
  providedIn: 'root'
})
export class HelperServiceService {

  constructor(private toaster: ToasterService) { }

  getImageWithAspectCheck(
    event: Event,
    expectedAspect: 'square' | 'video' | 'none',
    options?: {
      label?: string;
      recommendedWidth?: number;
      recommendedHeight?: number;
    }
  ): Promise<any> {
    return new Promise((resolve) => {
      const input = event.target as HTMLInputElement;

      if (!input.files || input.files.length === 0) {
        return resolve({ image: null, imageUrl: null });
      }

      const file = input.files[0];
      const url = URL.createObjectURL(file);


      const recommendedWidth = options?.recommendedWidth;
      const recommendedHeight = options?.recommendedHeight;
      const label = options?.label ?? 'Thumbnail';

      // NOTE: this helper is used for image thumbnail uploads.
      // (Video-duration extraction should be handled by a dedicated video validator if needed.)


      if (file.size > 2 * 1024 * 1024) {
        const sizeMsg = `${label} should be under 2MB`;
        this.toaster.setToaster('error', 'Invalid Thumbnail', sizeMsg);
        return resolve({ image: null, imageUrl: null });
      }

      const img = new Image();

      img.onload = () => {
        if (expectedAspect !== 'none') {
          const aspect = img.width / img.height;
          const expected = expectedAspect === 'square' ? 1 : 16 / 9;

          // Allow ±5% tolerance
          if (Math.abs(aspect - expected) > 0.05) {
            const message = (() => {
              if (expectedAspect === 'square') {
                if (recommendedWidth && recommendedHeight) {
                  return `${label} should be ${recommendedWidth} x ${recommendedHeight}`;
                }
                return 'Please upload a square image (1:1 aspect ratio)';
              }
              if (expectedAspect === 'video') {
                if (recommendedWidth && recommendedHeight) {
                  return `${label} should be ${recommendedWidth} x ${recommendedHeight} (16:9)`;
                }
                return 'Please upload an image with 16:9 aspect ratio';
              }
              return 'Invalid image aspect ratio';
            })();

            this.toaster.setToaster('error', 'Invalid Thumbnail', message);
            return resolve({ image: null, imageUrl: null });
          }
        }

        // ✅ Valid image
        resolve({ image: file, imageUrl: url });
      };

      img.onerror = () => {
        this.toaster.setToaster('error', 'Error', 'Could not load image file');
        resolve({ image: null, imageUrl: null });
      };

      img.src = url;
    });
  }



  async generateElementPngBinary(
    elementRef: ElementRef<HTMLElement>
  ): Promise<Uint8Array | null> {
    const node = elementRef.nativeElement;

    try {
      const blob = await htmlToImage.toBlob(node, {
        filter: (n) => {
          return !(n as HTMLElement).classList?.contains('no-export');
        },
        backgroundColor: 'transparent',
        cacheBust: true,
        width: node.clientWidth,
        height: node.clientHeight
      });

      if (!blob) {
        return null;
      }

      const arrayBuffer = await blob.arrayBuffer();
      return new Uint8Array(arrayBuffer);
    } catch (err) {
      console.error('Binary generation failed:', err);
      return null;
    }
  }




}
